import { State } from '@/stores/quotes/state';
import { Actions } from '@/stores/quotes/actions';
import { Getters } from '@/stores/quotes/getters';
import { Mutations } from '@/stores/quotes/mutations';
import { Module } from 'vuex';

export class QuoteStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
